<script>
import { layoutComputed } from "@/state/helpers";
import Vertical from "./vertical";
import Loader from "@/components/loader";

export default {
  components: { Vertical, Loader },
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
  },
  methods: {},
};
</script>

<template>
  <div>
    <Loader v-if="loader === true" />
    <vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </vertical>
  </div>
</template>
